import { PermanentDetailViewModel, ProductFullDeatilViewModel } from "@payping/api";

export interface FormWrapperProps {
  title: string;
  loadingProduct?: boolean;
  loadingLink?: boolean;
  loadingCoupon?: boolean;
  productDetails?: ProductFullDeatilViewModel;
  linkDetails?: PermanentDetailViewModel;
  havePerma?: boolean;
  locationSearch?: string;
}
export enum CouponType {
  Percent = 0,
  Toman = 1,
}
export interface LocationStateSearch {
  locationSearch?: string;
}

export interface ListQueryParamsType {
  isArchived?: boolean;
  searchText?: string;
  pageNumber?: number;
  pageSize?: number;
}
export type ListStringQueryParamsType = Pick<ListQueryParamsType, "searchText">;
export type ListNumberQueryParamsType = Pick<ListQueryParamsType, "pageNumber" | "pageSize">;
export type ListBoolQueryParamsType = Pick<ListQueryParamsType, "isArchived">;
